export class UpdateTitleValueDigitalRequest {
  documentType?: string;
  documentNumber?: string;
  user?: string;
  authorization?: string;
  titleValue?: string;
  modificationType?: string; // 'posfechado' | 'titulo_valor'
  newDate?: string;
  newTitleValue?: string;

  public static forDatePostponement(
    base: Pick<UpdateTitleValueDigitalRequest, 'documentType' | 'documentNumber' | 'user' | 'authorization' | 'titleValue'>,
    newDate: string
  ): UpdateTitleValueDigitalRequest {
    return {
      ...base,
      modificationType: 'posfechado',
      newDate,
    };
  }

  public static forTitleValueUpdate(
    base: Pick<UpdateTitleValueDigitalRequest, 'documentType' | 'documentNumber' | 'user' | 'authorization' | 'titleValue'>,
    newTitleValue: string
  ): UpdateTitleValueDigitalRequest {
    return {
      ...base,
      modificationType: 'titulo_valor',
      newTitleValue,
    };
  }

  public static toRequest(request: UpdateTitleValueDigitalRequest): any {
    const params: any = {
      id_pais: 1,
      documento: request.documentNumber,
      tipo_documento: request.documentType,
      usuario: request.user,
      autorizacion: request.authorization,
      titulo_valor: request.titleValue,
      tipo_modificacion: request.modificationType,
    };

    if (request.modificationType === 'posfechado') {
      params.posfechado = request.newDate;
    }

    if (request.modificationType === 'titulo_valor') {
      params.titulo_valor_actualizar = request.newTitleValue;
    }

    return params;
  }
}